<template>
	<div>
		<v-subheader class="text-xs-left pl-0">Use Permission Groups to manage custom access across the platform. Assign specific permissions to groups and add employees to those groups to control what they can see and do. </v-subheader>
		<security-groups-list />
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import SecurityGroupsList from '@/components/security/SecurityGroupsList';

	export default {
		components: {
			SecurityGroupsList
		},
		data() {
			return {};
		},
		async created() {
			this.$store.dispatch('setPageTitle', 'Custom Permissions');

			if (!this.hasLoadedSecurityGroups) {
				await this.$store.dispatch('privileges/getSecurityGroups');
			}

			if (!this.hasLoadedAvailableFeatures) {
				await this.$store.dispatch('privileges/getAvailableFeatures');
			}
		},
		computed: {
			...mapGetters({
				loggedInEmployee: 'loggedInEmployee',
				hasLoadedAvailableFeatures: 'privileges/hasLoadedAvailableFeatures',
				hasLoadedSecurityGroups: 'privileges/hasLoadedSecurityGroups',
				securityGroups: 'privileges/securityGroups'
			})
		},
		methods: {
			cancel() {
				window.history.back();
			}
		}
	};
</script>

<style></style>
